<div class="relative w-full space-y-2">
  <!-- Label (if provided) -->
  @if (label()) {
  <app-input-label [required]="required()">{{ label() }}</app-input-label>
  }

  <!-- Search Input -->
  <app-input
    #searchInput
    type="search"
    id="typeahead-search-input"
    [placeholder]="placeholder()"
    [formControl]="searchControl"
    [required]="required()"
    [disabled]="disabled()"
    (focus)="onFocus()"
    (blur)="onBlur()"
  ></app-input>

  <!-- Selected Items as Chips -->
  @if (getSelectedCount() > 0) {
  <div class="flex flex-wrap gap-2">
    @for (selectedItem of getSelectedValues(); track selectedItem) {
    <app-chip
      color="medium"
      [clickable]="true"
      class="group relative"
    >
      {{ getDisplayString(selectedItem) }}
      <button
        type="button"
        class="ml-2 hover:text-danger transition-colors"
        (click)="onRemoveChip(selectedItem); $event.stopPropagation()"
      >
        <app-icon name="close" size="xs"></app-icon>
      </button>
    </app-chip>
    }
  </div>
  }

  <!-- Dropdown List -->
  @if (showDropdown()) {
  <div class="dropdown-container">
    <div class="dropdown-list">
      @if (filteredOptions().length > 0) {
        @for (option of filteredOptions(); track option) {
        <div
          class="dropdown-item"
          (mousedown)="onOptionClick(option); $event.preventDefault()"
          [class.selected]="isSelected(option)"
        >
          @if (multiSelect()) {
          <app-checkbox-input
            [checked]="isSelected(option)"
            (click)="$event.preventDefault()"
            class="pointer-events-none"
          >
            {{ getDisplayString(option) }}
          </app-checkbox-input>
          } @else {
          <div class="flex items-center">
            @if (isSelected(option)) {
            <span class="mr-2 text-blue-500">✓</span>
            }
            <span>{{ getDisplayString(option) }}</span>
          </div>
          }
        </div>
        }
      } @else {
      <div class="dropdown-empty">
        <span class="text-medium">No matches found</span>
      </div>
      }
    </div>
  </div>
  }
</div>

